module.exports = __webpack_public_path__ + "img/glasses-img3.7b457fdd.png";